export function createForestAmbient() {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  const ctx = new Ctx();
  const master = ctx.createGain();
  master.gain.value = 0.22;
  master.connect(ctx.destination);
  const size = 2 * ctx.sampleRate;
  const buffer = ctx.createBuffer(1, size, ctx.sampleRate);
  const ch = buffer.getChannelData(0);
  for (let i = 0; i < size; i++) ch[i] = Math.random() * 2 - 1;
  const noise = ctx.createBufferSource();
  noise.buffer = buffer;
  noise.loop = true;
  const lp = ctx.createBiquadFilter();
  lp.type = "lowpass";
  lp.frequency.value = 380;
  const windGain = ctx.createGain();
  windGain.gain.value = 0.4;
  noise.connect(lp);
  lp.connect(windGain);
  windGain.connect(master);
  noise.start();
  const pad = ctx.createGain();
  pad.gain.value = 0.05;
  pad.connect(master);
  const oscs = [110, 164.8, 220.5].map((f) => {
    const o = ctx.createOscillator();
    o.type = "sine";
    o.frequency.value = f;
    o.connect(pad);
    o.start();
    return o;
  });
  const chirp = setInterval(() => {
    if (ctx.state !== "running") return;
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = "sine";
    o.frequency.value = 1300 + Math.random() * 1400;
    g.gain.setValueAtTime(0.0001, ctx.currentTime);
    g.gain.linearRampToValueAtTime(0.045, ctx.currentTime + 0.06);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.45);
    o.connect(g);
    g.connect(master);
    o.start();
    o.stop(ctx.currentTime + 0.5);
  }, 2400 + Math.random() * 1500);
  return {
    stop: () => {
      clearInterval(chirp);
      oscs.forEach((o) => { try { o.stop(); } catch {} });
      try { noise.stop(); } catch {}
      ctx.close();
    },
  };
}
